import { sendErrorAtDev } from './utils';
function getUniqueId() {
  return "".concat(new Date().getTime()).concat(parseInt(String(Math.random() * 100), 10));
}
/**
 * svg过滤内容，去除不必要的参数，并发出警告
 * @param svgElement
 * @param svgUrl
 */
export default function filterUnavailableSvgContent(svgElement, svgUrl) {
  var scripts = svgElement.querySelectorAll('script');
  if (scripts.length > 0) {
    sendErrorAtDev("Svg(".concat(svgUrl, ") cannot contain script inside."));
    for (var i = 0, scriptsLen = scripts.length; i < scriptsLen; i++) {
      svgElement.removeChild(scripts[i]);
    }
  }
  // const defs = svgElement.querySelectorAll('defs');
  // if (defs.length > 0) {
  //   sendErrorAtDev(`Svg(${svgUrl}) cannot contain defs inside.`);
  // for (let i = 0, defsLen = defs.length; i < defsLen; i++) {
  //   svgElement.removeChild(defs[i]);
  // }
  // }
  var hasIdElements = svgElement.querySelectorAll('[id]');
  if (hasIdElements.length > 0) {
    // TODO:: 这里只处理渐变，其他等具体使用时在确定，
    // TODO:: 升级，对于渐变图标，可考虑使用雪碧图+background进行处理，而不是图标
    // 处理渐变色，同一个页面多次引入时，id相同的情况下（采用国际化资源标识符IRI），会导致样式问题，
    var IRIElementsAndProperties_1 = {
      linearGradient: ['fill', 'stroke'],
      radialGradient: ['fill', 'stroke']
    };
    var isAvailableId_1 = false;
    Object.keys(IRIElementsAndProperties_1).forEach(function (tagName) {
      var properties = IRIElementsAndProperties_1[tagName];
      var elements = svgElement.querySelectorAll("".concat(tagName, "[id]"));
      if (!isAvailableId_1) {
        isAvailableId_1 = elements.length > 0;
      }
      var _loop_1 = function _loop_1(a, elementsLen) {
        var currentId = elements[a].id;
        var newId = "".concat(currentId, "-").concat(getUniqueId());
        // 引用id属性的元素列表
        var referencingElements;
        // 过滤所有属性并替换成新的id
        Array.prototype.forEach.call(properties, function (property) {
          // 获取引用的元素
          referencingElements = svgElement.querySelectorAll("[".concat(property, "*=\"").concat(currentId, "\"]"));
          for (var b = 0, referencingElementLen = referencingElements.length; b < referencingElementLen; b++) {
            var attrValue = referencingElements[b].getAttribute(property);
            if (attrValue && !attrValue.match(new RegExp("url\\(\"?#".concat(currentId, "\"?\\)")))) {
              continue;
            }
            referencingElements[b].setAttribute(property, "url(#".concat(newId, ")"));
          }
        });
        elements[a].id = newId;
      };
      for (var a = 0, elementsLen = elements.length; a < elementsLen; a++) {
        _loop_1(a, elementsLen);
      }
    });
    // 已经处理的id不再警告
    if (!isAvailableId_1) {
      sendErrorAtDev("Svg(".concat(svgUrl, ") cannot contain id attribute inside."));
    }
    // for (let i = 0, hasIdElementsLen = hasIdElements.length; i < hasIdElementsLen; i++) {
    //   hasIdElements[i].removeAttribute('id');
    // }
  }

  var hasClassElements = svgElement.querySelectorAll('[class]');
  if (hasClassElements.length > 0) {
    sendErrorAtDev("Svg(".concat(svgUrl, ") cannot contain class name attribute inside."));
    // for (let i = 0, hasClassElementsLen = hasIdElements.length; i < hasClassElementsLen; i++) {
    //   hasIdElements[i].removeAttribute('class');
    // }
  }
}